import React from "react";
import { checkString, getName } from "../../CommonMethhods/CommonMethods";
import SmallLoader from "../../Components/Common/smallLoader";
import { useEffect } from "react";
import { useState } from "react";

function PartnerDashboardDetails(props) {
  let partnerData = props.partnerData;
  console.log(partnerData, "partnerData9999");
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankList, setBankList] = useState([]);
  const loader = props.loader;
  function addressArray(array) {
    let a = "";
    array.forEach((item) => {
      if (item?.length > 0) {
        if (item != " " && item != "NA") a = a + item + ",";
      }
    });
    return a.length > 0 ? a : "NA";
  }

  const Address1 =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.address1);

  const Address2 =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.address2);

  const Address3 =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.address3);

  const State =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.state);

  const City =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.city);

  const Zip =
    partnerData === undefined || null
      ? "NA"
      : checkString(partnerData?.addressdtls?.zip);

  const GetFName =
    partnerData === undefined || null
      ? " "
      : partnerData?.fName === undefined || null
      ? " "
      : partnerData?.fName;

  const GetMName =
    partnerData === undefined || null
      ? " "
      : partnerData?.mName === undefined || null
      ? " "
      : partnerData?.mName;

  const GetLName =
    partnerData === undefined || null
      ? " "
      : partnerData?.lName === undefined || null
      ? " "
      : partnerData?.lName;

  let firstName = GetFName.charAt(0);
  let lastName = GetLName.charAt(0);

  useEffect(() => {
    if (partnerData?.bankdtls?.length) {
      const primaryBank = partnerData?.bankdtls.find(
        (bank) => bank?.isPrimary === true
      );
      setSelectedBank(primaryBank);
      setBankList(partnerData?.bankdtls);
    }
  }, [partnerData]);

  // const handleBankChange = (event) => {
  //   const selectedBankId = event.target.value;
  //   const bank = bankList.find(
  //     (bank) => bank?.bankId === parseInt(selectedBankId)
  //   );
  //   setSelectedBank(bank);
  // };

  console.log(selectedBank, "selectedBank");

  return (
    <>
      <div className="user-profile card-box  partner-application">
        <div>
          <div className="user-profile__top">
            <div className="profile__details d-flex">
              <div className="profile__img">
                {partnerData === undefined || null ? (
                  <h2 className="profile-img-name">NA</h2>
                ) : partnerData?.profilePic === undefined || null || " " ? (
                  <h2 className="profile-img-name">{firstName + lastName}</h2>
                ) : (
                  <img
                    className="profile-pic"
                    src={partnerData?.profilePic}
                    alt="User Profile Icon"
                  />
                )}
              </div>
              <div className="profile__details__wrapper">
                <div className="user__details">
                  <div>
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h3 className="user__details__name">
                        {GetFName + " " + GetMName + " " + GetLName}
                      </h3>
                    )}
                  </div>
                  <div>
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <p className="contact__detail client-id">
                        {partnerData === undefined || null
                          ? "NA"
                          : checkString(partnerData?.clientCode)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="user-profile__bottom row">
            <div className="col-12 col-md-6 contact">
              <p className="contact-number contact__details">
                <span className="icon-phone-icon"> </span>

                {loader ? (
                  <SmallLoader />
                ) : partnerData === undefined || null ? (
                  "NA"
                ) : (
                  checkString(partnerData?.mobno)
                )}
              </p>

              <p className="email contact__details">
                <span className="icon-email"></span>
                {loader ? (
                  <SmallLoader />
                ) : partnerData === undefined || null ? (
                  "NA"
                ) : (
                  checkString(partnerData?.emailid)
                )}
              </p>
              <p className="location contact__details">
                <span className="icon-location"></span>

                {/* {Address1 + "," + Address2 + "," + Address3 + "," + State + "," + City + "," + Zip} */}
                {loader ? (
                  <SmallLoader />
                ) : (
                  // </div>
                  addressArray([Address1, Address2, Address3, State, City, Zip])
                )}
              </p>

              <p className="code contact__details">
                <span className="icon-id-card"></span>
                {loader ? (
                  <SmallLoader />
                ) : partnerData === undefined || null ? (
                  "NA"
                ) : (
                  checkString(partnerData?.pan)
                )}
              </p>
            </div>
            <div className="col-12 col-md-6 contact-right">
              <div className="contact-right__top d-flex align-items-end">
                <div className="referred-by">
                  <p className="bank-title">Bank Details</p>
                </div>
              </div>
              <ul className="contact-right__bottom">
                <li className="referrence-details">
                  <p className="bank-label">Bank Name:</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) : selectedBank === undefined || null || "" ? (
                      "NA"
                    ) : (
                      checkString(selectedBank?.bankName)
                    )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label">Account Number:</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) : selectedBank === undefined || null || "" ? (
                      "NA"
                    ) : (
                      checkString(selectedBank?.acNo)
                    )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label">IFSC Code:</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) : selectedBank === undefined || null ? (
                      "NA"
                    ) : (
                      checkString(selectedBank?.ifsc)
                    )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label">Branch Name:</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) : selectedBank === undefined || null ? (
                      "NA"
                    ) : (
                      checkString(selectedBank?.branch)
                    )}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </>
  );
}

export default PartnerDashboardDetails;
